import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

/**
 * A customizable textarea component with improved UX defaults
 */
export const Textarea = forwardRef(function Textarea(
  { className, rows = 4, placeholder, ...props },
  ref
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      placeholder={placeholder}
      {...props}
      className={clsx(
        className,
        // Base styling
        'block w-full rounded-xl border border-border-gray bg-white px-4 py-3',
        'text-gray-dark placeholder:text-gray-mid',
        'font-sans text-base leading-relaxed',

        // Focus states
        'focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent',

        // Hover states
        'hover:border-gray-400 transition-colors duration-200',

        // Disabled states
        'disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed',

        // Read-only states
        'read-only:bg-gray-50 read-only:border-gray-300 read-only:cursor-default',

        // Better textarea-specific styling
        'resize-y min-h-[100px]'
      )}
    />
  );
});

Textarea.propTypes = {
  className: PropTypes.string,
  rows: PropTypes.number,
  placeholder: PropTypes.string,
};
